import { Component, ErrorInfo, ReactNode } from 'react';
import Ybutton from 'controls/Ybutton';
import YcustomButton from 'controls/YcustomButton';
import { homeServices } from 'services/home/home.services';

// Utility function to log errors to the console
const logError = (message: string): void => {
  const timeStamp = new Date().toISOString();
  const logMessage = `${timeStamp} - ${message}`;
  console.error(logMessage);
};

// Utility function to safely access nested properties
const getNestedProperty = <T, K extends keyof T>(
  obj: T, 
  propertyPath: string, 
  description = ''
): any => {
  try {
      const properties = propertyPath.split('.');
      let current: any = obj;
      for (const property of properties) {
          if (current[property] === undefined) {
              throw new Error(`${description} Property '${property}' is undefined.`);
          }
          current = current[property];
      }
      return current;
  } catch (error: any) {
      logError(`${description} Error accessing nested property: ${error.message}`);
      return undefined; // Return undefined or handle the error accordingly
  }
};

export {
  getNestedProperty,
  logError
};

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
      super(props);
      this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
      return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
      this.logErrorToServer(error, errorInfo);
  }

  async logErrorToServer(error: any, errorInfo: ErrorInfo): Promise<void> {
      const reqParam={
        message : `portal: ${error.toString()} on page ${window.location.host + window.location.pathname}`,
      }
      console.log("reqParam",reqParam)
       await homeServices.writeErrorLog(reqParam);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <div className='container no-padding '>
            <div className='notFoundPage max-height'>
              <h6 className='smallText'>Oops, somthing went wrong.</h6>
              <p className='infoText'>There was a problem connecting to site.</p>
              <div className='actionButton'>
                <Ybutton round btnClass="customBtn" btnText="Reload" handleChangeValue={() => window.location.reload()}></Ybutton>
                <YcustomButton round outline btnClass="theme-outline-green" btnText="Go Home" handleChangeValue={() => (window.location.href = '/')} />
              </div>
            </div>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;


